import { render, staticRenderFns } from "./FormBudget.vue?vue&type=template&id=390c4138"
import script from "./FormBudget.vue?vue&type=script&lang=js"
export * from "./FormBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports